import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import img1 from "../assets/image 41.png";
import img2 from "../assets/image 42.png";
import img3 from "../assets/image 43.png";
import img5 from "../assets/motorbike 1.png";
import logo from "../assets/logo.png";
import { useTheme } from "@mui/material/styles";
import {
  SampleTypeList,
  DiseaseName,
  FilteredList,
  getAllCities
} from "../service/SearchlistService";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import "../App.css";
import { Divider, Modal, useMediaQuery } from "@mui/material";
import ListingData from "../components/ListingData";
import Loader from "../components/Loader";
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useSelector } from "react-redux";
import Cart from "../components/Cart";
import CloseIcon from '@mui/icons-material/Close';
import ExcelDownloadButton from "../components/ExcelDownloadButton";
import DownloadPdfFile from "../components/DownloadPdfFile";
import ReactGA from "react-ga4";
import CityPopup from "../components/CityPopup";
const drawerWidth = 260;

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 8,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "min(55%, 650px)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid #efecec",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};


const Navbar = (props) => {
  const theme = useTheme();
  const { cartItemList } = useSelector((s) => s.edos)
  const [diseaseName, setDiseaseName] = React.useState([]);
  const [sampleType, setSampleType] = React.useState([]);
  const [filteringData, setFilteringData] = React.useState([]);
  const [show, setShow] = React.useState(true);
  const [sendErrorMsg, setSendErrorMsg] = React.useState("");
  const [resetData, setResetData] = React.useState("");
  const [value, setValue] = React.useState(null);
  const [value2, setValue2] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");
  const [inputValue2, setInputValue2] = React.useState("");
  const [inputValue3, setInputValue3] = React.useState("");
  const [cities, setCities] = React.useState([]);
  const [cityValue, setCityValue] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false)
  const [openPop, setOpenPop] = React.useState(false)
  const [filterValue, setFilterValue] = React.useState(
    { cityId: null, specimenId: null, diseaseId: null }
  )

  const toogleHandler = () => {
    setShow(!show);
  };

  const isGreaterThanSmallBreakpoint = useMediaQuery(
    theme.breakpoints.up("md")
  );

  // API CALLLS BASED ON CHANGES----------
  React.useMemo(async () => {
    if (filterValue.cityId || filterValue.diseaseId || filterValue.specimenId) {
      setLoading(true)
      await FilteredList(filterValue).then((res) => {
        setLoading(false)
        if (res?.data?.length === 0) {
          setFilteringData([]);
          setSendErrorMsg("No Data Available");
        } else {
          setFilteringData(res?.data);
          setSendErrorMsg();
          setResetData("delete");
        }
      });
    }
  }, [filterValue])

  // SAMPLE_TYPE LIST-API CALLING
  React.useEffect(() => {
    ReactGA.event({
      category: 'Apollo Diagnostics Dashboard',
      action: 'Apollo Diagnostics Dashboard Page',
      label: "Apollo Diagnostics Dashboard Page",
      nonInteraction: true,
      transport: "xhr"
    });

    const sampletypelist = async () => {
      await SampleTypeList().then((res) => {
        setSampleType(res.data);

      });
    };
    sampletypelist();
    diseasename();
  }, []);

  // WHEN SESSION CITY ID IS AVAILABLE
  React.useEffect(() => {
    if (sessionStorage.getItem("city_id") && cities?.length > 0) {
      const filterCityy = cities.filter((res) => res.id == sessionStorage.getItem("city_id"))
      setCityValue(filterCityy[0]);
      setInputValue3(filterCityy[0]?.city_name)
      setFilterValue((prevState) => {
        return {
          ...prevState,
          cityId: filterCityy[0]?.center_code,
          specimenId: null,
          diseaseId: null
        };
      });
      setInputValue("")
      setInputValue2("")
      setValue2(null)
      setValue(null)
      setOpenPop(false)
    } else {
      setOpenPop(true)
    }
  }, [sessionStorage.getItem("city_id"), cities])

  const diseasename = async () => {
    setLoading(true)
    try {
      await DiseaseName().then((res) => {
        setLoading(false)
        if (res.data) {
          setDiseaseName(res.data);
        }
      })
    } catch (error) {
      setLoading(false)
    }

  };

  // API FOR GETTING DISEASE NAME
  React.useEffect(() => {
    const getCities = async () => {
      setLoading(true)
      try {
        await getAllCities().then((res) => {
          setLoading(false)
          if (res.data) {
            setCities(res.data);
          }
        })

      } catch (error) {
        setLoading(false)
      }

    };
    getCities();
  }, []);

  const SampleTypehandler = (e) => {
    if (e === null) {
      setInputValue("");
      setFilterValue((prevState) => {
        return {
          ...prevState,
          specimenId: null,
        };
      });
    } else {
      setFilterValue((prevState) => {
        return {
          ...prevState,
          // specimenId: e.id,
          specimenId: e.specimen_type
        };
      });

    }
  };
  // ----------CITY HANDLER--------------------------
  const cityHandler = (e) => {
    if (e === null) {
      setInputValue3("")
      setFilteringData([]);
      setFilterValue((prevState) => {
        return {
          ...prevState,
          cityId: null,
          specimenId: null,
          diseaseId: null
        };
      });
    } else {
      setFilterValue((prevState) => {
        return {
          ...prevState,
          cityId: e.center_code,
          specimenId: null,
          diseaseId: null
        };
      });

      sessionStorage.setItem("city_id", e.id)
    }
    setInputValue("")
    setInputValue2("")
    setValue2(null)
    setValue(null)

  };

  const DiseaseNamehandler = (e) => {
    if (e === null) {
      setInputValue2("")
      setFilterValue((prevState) => {
        return {
          ...prevState,
          diseaseId: null
        };
      });
    } else {
      setFilterValue((prevState) => {
        return {
          ...prevState,
          diseaseId: e.disease_name
        };
      });
    }


  };

  const cancelHandler = () => {
    setFilteringData([]);
    setCityValue("")
    window.location.reload(false);
    setValue([]);
    setValue2([]);
    setInputValue("");
    setInputValue2("");
    setInputValue3("");
    setFilterValue({ cityId: null, specimenId: null, diseaseId: null })
  };

  // ADDING ITEMS IN THE CART------
  // for modal ------------------------

  const handleClose = () => {
    setOpen(false);
  };

  const getItemId = (id) => {
    sessionStorage.setItem("city_id", id)
    const filterCity = cities.filter((res) => res.id == id)
    setCityValue(filterCity[0]);
    setInputValue3(filterCity[0]?.city_name)
    setFilterValue((prevState) => {
      return {
        ...prevState,
        cityId: filterCity[0]?.center_code,
        specimenId: null,
        diseaseId: null
      };
    });
    setInputValue("")
    setInputValue2("")
    setValue2(null)
    setValue(null)
    setOpenPop(false)
  }

  return (
    <Box sx={{ display: "flex" }}>

      {loading && <Loader />}
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: "white",
        }}
        className="top-bar"
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>

          <Box className="logo">
            <Box sx={{ display: { xs: "contents", md: "none" } }}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={toogleHandler}
              >
                <MenuIcon color="primary" />
              </IconButton>
            </Box>
            <img src={logo} alt="title" />
            <IconButton aria-label="cart" onClick={() => setOpen(true)} sx={{ display: { xs: "contents", md: "none" } }}>
              <StyledBadge badgeContent={cartItemList.length} color="secondary" sx={{ mt: '20px' }}>
                <ShoppingCartIcon />
              </StyledBadge>
            </IconButton>
          </Box>
          <Box className="certified-logos">
            <img src={img1} alt="logo title" className="imgHeader" />
            <img src={img2} alt="logo title" className="imgHeader" />
            <img src={img3} alt="logo title" className="imgHeader" />
            {/* <img src={img4} alt="logo title" className="imgHeader" /> */}
            <img src={img5} alt="logo title" className="imgHeader" />

            <Typography
              variant="h7"
              noWrap
              component="div"
              sx={{ color: "black" }}
            >
              Home Collection <br />
              040-44442424
            </Typography>

            <IconButton aria-label="cart" onClick={() => setOpen(true)}>
              <StyledBadge badgeContent={cartItemList.length} color="secondary">
                <ShoppingCartIcon />
              </StyledBadge>
            </IconButton>

          </Box>
        </Toolbar>
      </AppBar>
      {/* POP_UP */}
      {!sessionStorage.getItem("city_id") && (
        <CityPopup getItemId={getItemId} openPop={openPop} />
      )}

      {/* {show && ( */}
      <Drawer
        id="drawer"
        variant={isGreaterThanSmallBreakpoint ? "permanent" : "temporary"}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
          zIndex: "5px",

          // display: { xs: "none", md: "flex" },
        }}
      >
        <Toolbar />
        <Box
          sx={{
            overflow: "auto",
            padding: "10px",
            background: "#00799E",
            height: "100vh",
          }}
        >
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ color: "white", my: 1, fontSize: "14px" }}
          >
            Select your city
          </Typography>
          <Autocomplete
            value={cityValue}
            inputValue={inputValue3}
            getOptionLabel={(cities) => `${cities?.city_name}`}
            options={cities}
            isOptionEqualToValue={(option, value) =>
              option?.id === value?.id
            }
            noOptionsText={"No Data Available"}
            sx={{ width: "100%", background: "white", borderRadius: "6px" }}
            renderOption={(props, cities) => (
              <Box component="li" sx={{ fontSize: "14px" }} {...props} key={cities?.id}>
                {cities?.city_name ? cities.city_name.charAt(0).toUpperCase() + cities.city_name.slice(1).toLowerCase() : cities?.city_name}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select your city"
                variant="filled"
                size="small"
              />
            )}
            onChange={(e, newValue) => {
              cityHandler(newValue);
              setCityValue(newValue);
            }}
            onInputChange={(event, newInputValue) => {
              if (event) {
                newInputValue !== "undefined"
                  ? setInputValue3(newInputValue)
                  : setInputValue3("");
              }
            }}
          />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ color: "white", my: 1, fontSize: "14px" }}
          >
            Sample Type
          </Typography>

          <Autocomplete
            value={value}
            inputValue={inputValue}
            getOptionLabel={(sampleType) => `${sampleType?.specimen_type}`}
            options={sampleType}
            isOptionEqualToValue={(option, value) =>
              option?.id === value?.id
            }
            noOptionsText={"No Data Available"}
            sx={{ width: "100%", background: "white", borderRadius: "6px" }}
            renderOption={(props, sampleType) => (
              <Box component="li" {...props} sx={{ fontSize: "14px" }} key={sampleType?.id}>
                {sampleType?.specimen_type}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Sample Type"
                variant="filled"
                size="small"
              />
            )}
            onChange={(e, newValue) => {
              SampleTypehandler(newValue);
              setValue(newValue);
            }}
            onInputChange={(event, newInputValue) => {
              if (event) {
                newInputValue !== "undefined"
                  ? setInputValue(newInputValue)
                  : setInputValue("");
              }
            }}
          />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ color: "white", my: 1, fontSize: "14px" }}
          >
            Disease Name
          </Typography>
          <Autocomplete
            value={value2}
            inputValue={inputValue2}
            getOptionLabel={(diseaseName) => `${diseaseName?.disease_name}`}
            options={diseaseName}
            isOptionEqualToValue={(option, value) =>
              option.id === value.id
            }
            onChange={(e, newValue) => {
              DiseaseNamehandler(newValue);
              setValue2(newValue);
            }}
            noOptionsText={"No Data Available"}
            sx={{ width: "100%", background: "white", borderRadius: "6px" }}
            renderOption={(props, diseaseName) => (
              <Box component="li" {...props} sx={{ fontSize: "14px" }} key={diseaseName?.id}>
                {diseaseName?.disease_name}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Disease Name"
                variant="filled"
                size="small"
              />
            )}
            onInputChange={(event, newInputValue) => {
              if (event) {
                newInputValue !== "undefined"
                  ? setInputValue2(newInputValue)
                  : setInputValue2("");
              }
            }}
          />
          <Stack direction="row" spacing={4} sx={{ margin: "20px 20px", display: 'flex', justifyContent: "center" }}>
            <Button
              variant="outlined"
              sx={{
                color: "#FBBA00",
                background: "white",
                border: "2px solid #FBBA00",
                borderRadius: "18px",
                "&:hover": {
                  color: "#FBBA00",
                  background: "white",
                  border: "2px solid #FBBA00"
                }
              }}
              onClick={cancelHandler}
            >
              Clear
            </Button>
            {/* <Button
              disabled={filterValue.cityId ? false : true}
              variant="contained"
              sx={{ background: "#FBBA00", borderRadius: "18px" }}
              onClick={submitHandler}
            >
              Apply
            </Button> */}
          </Stack>
          {/* <Typography
            variant="body2"
            component="div"
            sx={{
              color: "#FFD700",
              my: 2,
              fontSize: "14px",
              textAlign: "center",
              padding: "10px",
              backgroundColor: "rgba(255, 215, 0, 0.1)",
              borderRadius: "6px",
              border: "1px solid rgba(255, 215, 0, 0.3)"
            }}
          >
            <ReportProblemIcon sx={{ color: "#FFD700", fontSize: "14px" }} /> The mentioned TAT refers to the processing time from sample receipt at the testing laboratory to reporting. Kindly add logistic TAT for samples transported from other cities.
          </Typography> */}
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Box>
          <Drawer
            id="drawer"
            variant={
              isGreaterThanSmallBreakpoint || show ? "temporary" : "permanent"
            }
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: drawerWidth,
                boxSizing: "border-box",
              },
              zIndex: "5px",
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <Toolbar />
            <Box
              sx={{
                overflow: "auto",
                padding: "10px",
                background: "#00799E",
                height: "100vh",
              }}
            >
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ color: "white", my: 1, fontSize: "14px" }}
              >
                Select your city
              </Typography>
              <Autocomplete
                value={cityValue}
                inputValue={inputValue3}
                getOptionLabel={(cities) => `${cities?.city_name}`}
                options={cities}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                noOptionsText={"No Data Available"}
                sx={{ width: "100%", background: "white", borderRadius: "6px" }}
                renderOption={(props, cities) => (
                  <Box component="li" {...props} key={cities?.id}>
                    {cities?.city_name ? cities.city_name.charAt(0).toUpperCase() + cities.city_name.slice(1).toLowerCase() : cities?.city_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select your city"
                    variant="filled"
                    size="small"
                  />
                )}
                onChange={(e, newValue) => {
                  cityHandler(newValue);
                  setCityValue(newValue);
                  toogleHandler();
                }}
                onInputChange={(event, newInputValue) => {
                  if (event) {
                    newInputValue !== "undefined"
                      ? setInputValue3(newInputValue)
                      : setInputValue3("");
                  }
                }}
              />
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ color: "white", my: 1, fontSize: "14px" }}
              >
                Sample Type
              </Typography>
              <Autocomplete
                value={value}
                inputValue={inputValue}
                getOptionLabel={(sampleType) => `${sampleType?.specimen_type}`}
                options={sampleType}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                noOptionsText={"No Data Available"}
                sx={{ width: "100%", background: "white", borderRadius: "6px" }}
                renderOption={(props, sampleType) => (
                  <Box
                    component="li"
                    {...props}
                    key={sampleType?.id}
                  >
                    {sampleType?.specimen_type}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Sample Type"
                    variant="filled"
                    size="small"
                  />
                )}
                onChange={(e, newValue) => {
                  SampleTypehandler(newValue);
                  setValue(newValue)
                  toogleHandler();
                }}
                onInputChange={(event, newInputValue) => {
                  if (event) {
                    // console.log(event);
                    // console.log(typeof newInputValue);
                    newInputValue !== "undefined"
                      ? setInputValue(newInputValue)
                      : setInputValue("");
                  }
                }}
              />
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{ color: "white", my: 1, fontSize: "14px" }}
              >
                Disease Name
              </Typography>
              <Autocomplete
                value={value2}
                inputValue={inputValue2}
                getOptionLabel={(diseaseName) => `${diseaseName?.disease_name}`}
                options={diseaseName}
                isOptionEqualToValue={(option, value) =>
                  option.id === value.id
                }
                onChange={(e, newValue) => {
                  DiseaseNamehandler(newValue);
                  setValue2(newValue);
                  toogleHandler();
                }}
                noOptionsText={"No Data Available"}
                sx={{ width: "100%", background: "white", borderRadius: "6px" }}
                renderOption={(props, diseaseName) => (
                  <Box component="li" {...props} key={diseaseName?.id}>
                    {diseaseName?.disease_name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Disease Name"
                    variant="filled"
                    size="small"
                  />
                )}
                onInputChange={(event, newInputValue) => {
                  if (event) {
                    newInputValue !== "undefined"
                      ? setInputValue2(newInputValue)
                      : setInputValue2("");
                  }
                }}
              />
              <Stack direction="row" spacing={4} sx={{ margin: "20px 20px", display: 'flex', justifyContent: "center" }}>
                <Button
                  sx={{
                    color: "#FBBA00",
                    background: "white",
                    border: "2px solid #FBBA00",
                    borderRadius: "18px",
                    "&:hover": {
                      color: "#FBBA00",
                      background: "white",
                      border: "2px solid #FBBA00",
                    },
                  }}
                  onClick={cancelHandler}
                >
                  Clear
                </Button>
                {/* <Button
                  disabled={filterValue.cityId ? false : true}
                  variant="contained"
                  sx={{ background: "#FBBA00", borderRadius: "18px" }}
                  onClick={submitHandler2}

                >
                  Apply
                </Button> */}
              </Stack>
              {/* <Typography
                variant="body2"
                component="div"
                sx={{
                  color: "#FFD700",
                  my: 2,
                  fontSize: "14px",
                  textAlign: "center",
                  padding: "10px",
                  backgroundColor: "rgba(255, 215, 0, 0.1)",
                  borderRadius: "6px",
                  border: "1px solid rgba(255, 215, 0, 0.3)"
                }}
              >
                <ReportProblemIcon sx={{ color: "#FFD700", fontSize: "14px" }} /> The mentioned TAT refers to the processing time from sample receipt at the testing laboratory to reporting. Kindly add logistic TAT for samples transported from other cities.
              </Typography> */}
            </Box>
          </Drawer>
        </Box>
        <Toolbar />
        <Box onClick={() => setShow(true)}>
          <ListingData
            filter={filteringData}
            errorMessage={sendErrorMsg}
            clicking={resetData}
            cartItemList={cartItemList}
          />
        </Box>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ display: "flex", justifyContent: "space-between", fontSize: '14px' }}>
              Cart Item List
              <IconButton onClick={() => handleClose()} color="error"><CloseIcon /></IconButton>
            </Typography>
            <Divider />
            <Box>
              <ExcelDownloadButton data={cartItemList} filename="TestData.xlsx" handleClose={handleClose} />
              <DownloadPdfFile data={cartItemList} />
            </Box>
            <Box>
              <Cart cartItemList={cartItemList} handleClose={handleClose} />
            </Box>


          </Box>
        </Modal>
      </Box>
    </Box>
  );
};

export default Navbar;
